import { USER_SET_USER } from '../constants/actionTypes';

const initialState = {
  user: {},
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_SET_USER:
      return {
        ...state,
        user: action.userInfo,
      };
    default:
      return state;
  }
};

export default userReducer;
